module.exports = __webpack_public_path__ + "assets/img/1461587607577_.pic_hd.daf4010e.jpg";